import React from "react";
import { RouteComponentProps } from "react-router";
import { AlertOptIn } from "halifax";

import { OptInConnectorProps } from "./container";
import { IAlertOptInCore } from "redmond";

export interface IOptInProps
  extends IAlertOptInCore,
    RouteComponentProps,
    OptInConnectorProps {
  smsBeenSelected: boolean;
  appNotifBeenSelected: boolean;
  hasSelectedDisruption: boolean;
  disruptionOptInEnabled: boolean;
  disrutpionDelayThresholdStringInHours: string;
  nonFDAdisruptionOptInEnabled: boolean;
  useUpdatedAlertOptIn?: boolean;
  hideSmsOptIn?: boolean;
  hideAppNotificationOptIn?: boolean;
}

export const OptIn = ({
  hasSelectedDisruption,
  smsBeenSelected,
  appNotifBeenSelected,
  toggleAppNotifOptIn,
  toggleSMSOptIn,
  disabled,
  disruptionOptInEnabled,
  nonFDAdisruptionOptInEnabled,
  tcpaConsentPhoneNumber,
  disrutpionDelayThresholdStringInHours,
  useUpdatedAlertOptIn,
  hideSmsOptIn,
  hideAppNotificationOptIn,
}: IOptInProps) => {
  if (
    (!disruptionOptInEnabled && !nonFDAdisruptionOptInEnabled) ||
    (useUpdatedAlertOptIn && !tcpaConsentPhoneNumber)
  ) {
    return null;
  }

  return (
    <AlertOptIn
      isMobile={false}
      appNotifBeenSelected={appNotifBeenSelected}
      smsBeenSelected={smsBeenSelected}
      toggleAppNotifOptIn={toggleAppNotifOptIn}
      toggleSMSOptIn={toggleSMSOptIn}
      hasSelectedDisruption={hasSelectedDisruption}
      disabled={disabled}
      disruptionOptInEnabled={disruptionOptInEnabled}
      nonFDAdisruptionOptInEnabled={nonFDAdisruptionOptInEnabled}
      tcpaConsentPhoneNumber={tcpaConsentPhoneNumber}
      disruptionDelayThresholdStringInHours={
        disrutpionDelayThresholdStringInHours
      }
      useUpdatedAlertOptIn={useUpdatedAlertOptIn}
      hideSmsOptIn={hideSmsOptIn}
      hideAppNotificationOptIn={hideAppNotificationOptIn}
    />
  );
};
